
import { showWarningNotification } from '../../../notifications/actions';
import { IconCameraEmpty, IconCameraEmptyDisabled } from '../../icons';

import AbstractButton, { type Props } from './AbstractButton';

/**
 * An abstract implementation of a button for toggling video mute.
 */
export default class AbstractVideoMuteButton<P : Props, S : *>
    extends AbstractButton<P, S> {

    icon = IconCameraEmpty;
    toggledIcon = IconCameraEmptyDisabled;

    /**
     * Handles clicking / pressing the button, and toggles the video mute state
     * accordingly.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const now = Date.now();

        this._lastToggleTimes = (this._lastToggleTimes || []).filter(t => now - t < 10000);
        if (this._lastToggleTimes.length >= 5) {
            const { dispatch, t } = this.props;

            if (typeof dispatch === 'function') {
                const titleKey = t ? t('chat.cameraRateLimitKey') : 'chat.cameraRateLimitKey';
                const descriptionKey = t ? t('chat.cameraRateLimitMessage') : 'chat.cameraRateLimitMessage';

                dispatch(showWarningNotification({
                    titleKey,
                    description: descriptionKey
                }));
            }

            return;
        }
        this._lastToggleTimes.push(now);

        this._setVideoMuted(!this._isVideoMuted());
    }

    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this._isVideoMuted();
    }

    /**
     * Helper function to be implemented by subclasses, which must return a
     * {@code boolean} value indicating if video is muted or not.
     *
     * @protected
     * @returns {boolean}
     */
    _isVideoMuted() {
        // To be implemented by subclass.
    }

    /**
     * Helper function to perform the actual setting of the video mute / unmute
     * action.
     *
     * @param {boolean} videoMuted - Whether video should be muted or not.
     * @protected
     * @returns {void}
     */
    _setVideoMuted() {
        // To be implemented by subclass.
    }
}
